import React, { Component } from "react";
import { Link } from "react-router-dom";
import { CurrentUserResource } from "../../stores/CurrentUserStore/Types";

interface Props {
  currentUser: CurrentUserResource;
}

class PaymentNavbar extends Component<Props, {}> {
  render() {
    const { currentUser } = this.props;

    return (
      <header className="checkout-nav">
        <div className="inner">
          <a
            href={currentUser.kind === "current-user" ? "/profile" : "/"}
            className="logo"
            aria-label="42courses home"
          >
            <img
              src={require("../../../../assets/images/landings/home-logo.svg")}
              alt="42courses logo"
              width="200"
              height="32"
            />
          </a>
          <div className="secure">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
            Secure checkout
          </div>
        </div>
      </header>
    );
  }
}

export default PaymentNavbar;
